import { API_BASE_URLS } from "./constant";

export const navigateToLogin = () => {
  localStorage.clear();
  window.location.href = API_BASE_URLS.login;
};
